var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00FF51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.172 24.728v-7.482h-2.536v-2.973h2.536V11.93c0-2.544 1.574-3.93 3.871-3.93 1.101 0 2.047.082 2.32.118v2.659H18.77c-1.25 0-1.49.588-1.49 1.448v2.048h2.82l-.388 2.973H17.28v7.481",
    fill: "#000"
  })));
};

export default SvgSocialFacebook;